import { render } from "./externship.vue?vue&type=template&id=6f42e2d0"
import script from "./externship.vue?vue&type=script&lang=js"
export * from "./externship.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__